// extracted by mini-css-extract-plugin
module.exports = {"openDialogButton":"styles_openDialogButton__2Qpho","buttonContainer":"styles_buttonContainer__1eruT","openDialogIcon":"styles_openDialogIcon__3PHgb"};